// extracted by mini-css-extract-plugin
export default {"player-container":"MXwxh2","playerContainer":"MXwxh2","poster":"mUCtKp","hide":"iSY3AP"};